<script>
/**
 * Descripción: BaseCard reutilizable
 *
 * @displayName BaseFeed
 */

import { butter } from '@/plugins/buttercms';
import NProgress from 'nprogress';

const BaseFeedCard = () =>
  import(
    /* webpackChunkName: "BlogViewComponent" */ '@/components/core/forms/BaseFeedCard'
  );

export default {
  name: 'BaseFeed',

  components: {
    BaseFeedCard
  },

  data: () => ({
    layout: [2, 2, 1, 2, 2, 3, 3, 3, 3, 3, 3],
    page: 1,
    posts: []
  }),

  computed: {
    pages() {
      return Math.ceil(this.posts.length / 11);
    },
    paginatedArticles() {
      const start = (this.page - 1) * 11;
      const stop = this.page * 11;
      return this.posts.slice(start, stop);
    }
  },

  watch: {
    page() {
      window.scrollTo(0, 0);
    }
  },

  created() {
    this.getPosts();
  },

  methods: {
    getPosts() {
      NProgress.start();
      butter.post
        .list()
        .then(res => {
          this.posts = res.data.data;
          NProgress.done();
        })
        .catch(res => {
          console.log(res);
        });
    }
  }
};
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <slot />
      </v-col>

      <BaseFeedCard
        v-for="(post, index) in this.posts"
        :key="post.slug + '_' + index"
        :size="layout[index]"
        :value="post"
      />
    </v-row>

    <v-row align="center">
      <v-col cols="3">
        <BaseButton
          v-if="page !== 1"
          class="ml-0"
          square
          title="Previous page"
          @click="page--"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </BaseButton>
      </v-col>

      <v-col class="text-center subheading" cols="6"
        >Página {{ page }} de {{ pages }}</v-col
      >

      <v-col class="text-right" cols="3">
        <BaseButton
          v-if="pages > 1 && page < pages"
          class="mr-0"
          square
          title="Next page"
          @click="page++"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </BaseButton>
      </v-col>
    </v-row>
    <br />
    <br />
  </v-container>
</template>
